<template>
    <div class="flex items-center" data-cy="draft-name-cell" @click.stop="handleRetrieve">
        <UButton
            size="xs"
            variant="ghost"
            icon="i-ph:pencil"
            title="Endre kladdnavn"
            data-cy="update-draft-name-button"
            @click.stop="editDraftName"
        />
        {{ props.params.data.name }}
    </div>
</template>

<script setup lang="ts">
import {Draft} from '@/draft/drafts.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: Draft,
            api: any,
            node: any,
            column: any,
            selectDraft: () => void,
        },
        required: true
    }
})

const editDraftName = () => {
    props.params.api.startEditingCell({
        rowIndex: props.params.node.rowIndex!,
        colKey: props.params.column!.getId(),
    })
}

const handleRetrieve = () => props.params.selectDraft()

</script>

<style scoped>

</style>